import { ComponentType, SVGProps } from 'react'
import { cn } from '@/lib/utils'
import { GraphUpIcon } from './icons'

export interface KpiColumn {
	label: string
	percent: string
	positive: boolean
	value: string
	decimals: string
}

interface KpiCardProps {
	title: string
	icon: ComponentType<SVGProps<SVGSVGElement>>
	gradientClassName: string
	bannerTextClassName: string
	columns: [KpiColumn, KpiColumn]
}

export function KpiCard({ title, icon: Icon, gradientClassName, bannerTextClassName, columns }: KpiCardProps) {
	return (
		<div className='relative min-w-0 flex-1 overflow-hidden rounded-[14px] border border-border bg-card shadow-[0_4px_12px_0_hsl(var(--background)/0.2)]'>
			<div className={cn('flex h-12 items-center justify-center gap-2 rounded-b-[24px] border-b border-border', gradientClassName)}>
				<Icon className={cn('h-6 w-6', bannerTextClassName)} />
				<span className={cn('text-base font-semibold tracking-[-0.24px]', bannerTextClassName)}>{title}</span>
			</div>

			<div className='flex flex-col gap-3 px-3 py-4 sm:flex-row sm:items-center sm:gap-4 sm:px-4 sm:py-5'>
				{columns.map((col, i) => (
					<div key={col.label} className='flex min-w-0 flex-1 items-center gap-4'>
						{i === 1 && <div className='hidden h-[66px] w-px shrink-0 bg-border sm:block' />}
						<div className='flex flex-1 flex-col items-center gap-3'>
							<div className='flex items-center gap-3'>
								<span className='text-base font-medium tracking-[-0.24px] text-foreground'>{col.label}</span>
								<span className={cn('flex items-center gap-1 text-sm font-semibold tracking-[-0.21px]', col.positive ? 'text-primary' : 'text-icon')}>
									<GraphUpIcon className='h-[18px] w-[18px]' />
									{col.percent}
								</span>
							</div>
							<div className='text-center tracking-[-0.24px]'>
								<span className='text-2xl font-semibold text-foreground'>{col.value}</span>
								<span className='text-base font-semibold text-muted-foreground'>{col.decimals}</span>
							</div>
						</div>
					</div>
				))}
			</div>
		</div>
	)
}
